import { FETCH_SHIPMENTS_SEARCH_RESULTS } from "../../../../../graphql/query/Shipment";
import { shipmentFilterStore } from "../../../components/useShipmentFilters";

const SearchedShipments = props => {
  const tableProps = {
    dataKey: "shipmentsV2",
    FETCH_QUERY: FETCH_SHIPMENTS_SEARCH_RESULTS,
    limit: 50,
    variables: {
      ...shipmentFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedShipments;
